export default __webpack_public_path__ + "static/media/confetti-background.adc4f767.png";